import { Component } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import {CropperPosition, Dimensions,ImageCroppedEvent,ImageTransform} from 'ngx-image-cropper';
import { SharedataService } from '../common/service/sharedata.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
})
export class UsersComponent extends BaseCtl {

  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  
  togglePassword(field: string) {
    if (field === 'old') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  public userContext: any = {};

  imagePreview: string | ArrayBuffer | null = null;

  public imagePath = '';

  public errorMessage: string | null = null;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private shareService: SharedataService
  ) {
    super('', locator, route);
    var _self = this;

    locator.getPathVariable(route, function (params: any) {
      _self.form.searchParams['appId'] = params['appId'];
    });

    let keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';

    // Get UserContext from localstorage
    const obj: any | null = JSON.parse(
      localStorage.getItem(keySuffix + 'userContext') ?? '{}'
    );
    // Set userContext in new varible
    _self.locator.config
      .getProperty('endpoint.user')
      .then((property: string) => {
        _self.initApiEndpoint(property);

        _self.userContext = obj;
        // Get profile details
        if (_self.userContext) {
          _self.form.data.id = _self.userContext['userId'];

          let url = property + '/profile';
          this.locator.http.get(url, function (res: any, error: boolean) {
            if (error) {
              alert('Server Error:' + error);
              return;
            }
            _self.form.error = !res.success;
            _self.form.message = res.message;
            _self.populateForm(_self.form.data, res.result.data);
          });
        }

        locator.getPathVariable(route, function (params: any) {
          _self.form.searchParams['appId'] = params['appId'];
        });
      });
  }

  /**
   * poplate data to form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.firstName = data.firstName;
    form.lastName = data.lastName;
    form.loginId = data.loginId;
    form.orgName = data.orgName;
    form.roleId = data.roleId;
    form.roleName = data.roleName;
    form.imageId = data.imageId;
  }

  /**
   * Get the thumbnail of the image
   * @param logo
   * @returns
   */
  getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }

  public resizeImage(file: any, maxWidth: any, maxHeight: any, callback: any) {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Enable cross-origin access if needed
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      let width = img.width;
      let height = img.height;

      // Calculate aspect ratio and resize
      if (width > maxWidth || height > maxHeight) {
        if (width > height) {
          height = Math.round((height *= maxWidth / width));
          width = maxWidth;
        } else {
          width = Math.round((width *= maxHeight / height));
          height = maxHeight;
        }
      }

      // Create canvas and check if context is available
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          callback(blob);
        }, 'image/png'); // PNG for lossless resizing
      } else {
        console.error('Canvas context is null. Unable to draw the image.');
      }
    };

    img.onerror = () => {
      console.error('Failed to load image. Please check the source.');
    };
  }

  /**
   * Show preview of the image
   * @param event
   */
  showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result; // Set the image preview
      };
      reader.readAsDataURL(file); 
    }
  }

  //-------------------------------------Change Passwords------------------------------------

  /**
   * Change password form
   */
  public cpForm: any = {
    error: false,
    message: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
    inputerror: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  };

  /**
   * Change the password
   *
   * @returns
   */
  changePassword() {
    let _self = this;

    if (_self.cpForm.oldPassword === _self.cpForm.newPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'Old and new password can not be same';
      return;
    }

    if (_self.cpForm.newPassword != _self.cpForm.confirmPassword) {
      _self.cpForm.error = true;
      _self.cpForm.message = 'New and confirm password are not matched';
      return;
    }

    _self.cpForm['loginId'] = _self.userContext['loginId'];

    let url =
      _self.locator.config.get('endpoint.login') +
      '/cp/' +
      _self.userContext['authKey'];
    _self.locator.http.post(url, _self.cpForm, function (res: any, error: any) {
      _self.cpForm.inputerror = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      };
      if (error) {
        return;
      }
      _self.cpForm.error = !res.success;
      _self.cpForm.message = res.message;

      if (_self.locator.dataValidator.isNotNullObject(res.result.inputerror)) {
        _self.cpForm.inputerror = res.result.inputerror;
      }
    });
  }

  public override clearMessage(obj: any) {
    obj['error'] = false;
    obj['message'] = null;
  }

  // -----------------Image Crop Function--------------------------

  enableCrop() {
    this.imageLoaded();
  }

  showCropper = false;
  isCropper = false;
  loading = false;
  croppedImage: SafeUrl = '';

  imageChangedEvent: Event | null = null;
  imageURL?: string;

  hidden = false;
  disabled = false;
  alignImage = 'center' as const;
  roundCropper = false;
  backgroundColor = 'grey';
  allowMoveImage = false;
  hideResizeSquares = false;
  canvasRotation = 0;
  aspectRatio = 4 / 3;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  cropperStaticWidth = 0;
  cropperStaticHeight = 0;
  cropperMinWidth = 0;
  cropperMinHeight = 0;
  cropperMaxWidth = 0;
  cropperMaxHeight = 0;
  resetCropOnAspectRatioChange = true;
  cropper?: CropperPosition;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  fileChangeEvent(event: Event): void {
    this.loading = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      event.objectUrl || event.base64 || ''
    );
    const base64 = event.base64;
    if (!base64) return;
    // Convert Base64 to File
    const file = this.base64ToFile(base64, this.imageName);

    this.croppedImageFile = file;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }

  transformChange(transform: ImageTransform) {}

  rotateLeft() {
    this.loading = true;
    setTimeout(() => {
      // Use timeout because rotating image is a heavy operation and will block the ui thread
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! - 1,
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! + 1,
    };
  }

  moveDown() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! + 1,
    };
  }

  moveUp() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! - 1,
    };
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  resetImage() {
    this.canvasRotation = 0;
    this.cropper = undefined;
    this.maintainAspectRatio = false;
    this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0,
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.1,
    };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.1,
    };
  }

  updateRotation(rotate: number) {
    this.transform = {
      ...this.transform,
      rotate,
    };
  }

  toggleAspectRatio() {
    this.aspectRatio = this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  toggleBackgroundColor() {
    this.backgroundColor = this.backgroundColor === 'red' ? 'blue' : 'red';
  }

  cancelCropping() {
    // Logic to cancel cropping and reset the cropper
    this.resetCropper();
    this.resetImage();
  }
  public croppedImageFile: File | null = null;

  resetCropper() {
    this.imageChangedEvent = null;
    this.showCropper = false;
    this.croppedImage = '';
    this.imageId = '';
    this.croppedImageFile = null;
  }

  private base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  public async saveCroppedImage() {
    var _self = this;
    if (!this.croppedImageFile) {
      alert('No cropped image available to save.');
      return;
    }

    await this.imageFormatter(this.croppedImageFile, 200, 200, 100);

    if (this.croppedImageFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
    }

    const code = this.imageCode;
    const imageId = 0;
    const url =
      this.locator.getEndpoint('endpoint.api.v1') +
      '/cuickdev/user/getPathImageUpload';

    const param = {
      id: this.form.data.id,
      path: this.imagePath,
      imageId: imageId,
      code: 'imageId',
    };

    this.locator.http.post(url, param, function (res: any, error: any) {
      if (error) {
        alert(error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
      if (res.success) {
        _self.form.message = 'File is uploaded successfully.';
        _self.form.data[code] = res.result.data[code];
        if (res.result.data?.imageId) {
          _self.form.data['imageId'] = res.result.data['imageId'];
          _self.shareService.updateSharedData('imageId',res.result.data?.imageId);
          
        }

        _self.changeDoc();
        _self.getDocThumbnail(_self.form.data[code]);
      }
    });

    this.resetCropper();
    this.resetImage()
  }

  public imageId: any = 0;
  public imageCode: any;
  public imageName: any;
  /**
   * Upload Image
   * @param event
   * @param code
   * @param imageId
   */

  fileError: boolean = false;
  imageSize: boolean = false;
  onFileChooseClicked(file: any) {
    file = '';
    this.croppedImageFile = null;
    this.fileError = false;
    this.imageSize = false;
    this.croppedImageFile = null;
    this.imagePreview = null;
    this.imageChangedEvent = null;
    this.imageURL = '';
    this.croppedImage = '';
    this.showCropper = false;
    this.resetImage()
    this.canvasRotation = 0;
       this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0,
    };
  }

  public onFileChanged(event: any, code: string, imageId: any) {
    // Show the cropper

    // Show the cropper
    const file = event.target.files[0];

    if (file) {
      // Check the file type
      const allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
      ];

      if (!allowedTypes.includes(file.type)) {
        // Set the error flag to true if the file type is not valid
        this.fileError = true;
        return;
      }
    }

    const fileObj = event.target.files[0];
    if (fileObj.size > 1 * 1024 * 1024) {
      this.imageSize = true;
      return;
    } else {
      this.imageSize = false;
      if (imageId === null || imageId === undefined) {
        imageId = 0;
      }
      this.fileChangeEvent(event);
      this.imageName = fileObj['name'];
      this.imageId = imageId;
      this.imageCode = code;
    }
  }

  resetFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = '';
    this.imageName = null;
    this.imageSize = false;
  }

  public async imageFormatter(
    file: File,
    width?: number,
    height?: number,
    filesizeKb?: number): Promise<void> {
    const endurl =
      this.locator.getEndpoint('endpoint.api.v1') +
      '/cuickdev/user/imageFormat';

    const url = this.urlRewrite(endurl);
    const formData = new FormData();
    formData.append('image', file);
    if (width) formData.append('width', width.toString());
    if (height) formData.append('height', height.toString());
    if (filesizeKb) formData.append('filesize_kb', filesizeKb.toString());

    const client = this.locator.http.getClient();

    try {
      const data: any = await new Promise((resolve, reject) => {
        client.post(url, formData, { responseType: 'json' }).subscribe(
          (response: any) => resolve(response),
          (error: any) => reject(error)
        );
      });
      console.log('data ', data);

      if (data.result.data?.path) {
        this.imagePath = data.result.data?.path;
      } else {
        this.form['error'] = true;
        this.form['message'] = 'Unexpected response structure';
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      this.form['error'] = true;
      this.form['message'] = 'Error uploading image';
    }
  }

  urlRewrite(endpoint: string) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId');
    if (!sid) {
      sid = '0';
    }
    endpoint = endpoint + ';jsessionid=' + sid;
    return endpoint;
  }

  subscribeToData() {
    this.shareService.getSharedData().subscribe({
      next: (data:any) => {
        this.imageId = data['imageId'];
        //this.dataFromService = data;
      },
      error: (err:any) => console.error('Error:', err),
    });
  }

  sharedata()
  {
    this.shareService.updateSharedData('name', this.form?.data.firstName + " " + this.form?.data.lastName);
     this.shareService.updateSharedData('imageId', this.form?.data.imageId);
  }

  override save(callback?: any): void {
    super.save();
    this.sharedata()
  }

  firstNameInvalid = false;
  lastNameInvalid = false;

  validateFirstName(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Trim leading & trailing spaces
    let value = input.value.trimStart();

    // Update the input field
    input.value = value;
    this.form.data['firstName'] = value;

    // Check if the input is empty after trimming spaces
    this.firstNameInvalid = value.length === 0;
  }

  validateLastName(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Trim leading & trailing spaces
    let value = input.value.trimStart();

    // Update the input field
    input.value = value;
    this.form.data['lastName'] = value;

    // Check if the input is empty after trimming spaces
    this.firstNameInvalid = value.length === 0;
  }

  override getDocThumbnail(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get("DOC_API");
    return docAPI + "th/" + skey + "?t=" + this.imageTimestamp;;
  }

  resetProfileImage() { 
  this.imagePreview = null; 
  this.form.data['imageId'] = null;  
    this.form.data['imageId'] = 0;
}
}
